<template>
  <div class="v-payment-create-form">
    <div class="text-center">
      <h5 v-bind:class="phone ? '' : 'font-weight-bold pt-3'">
        Быстрое пополнение баланса
      </h5>
    </div>
    <form class="form" @submit.prevent="createPayment">
      <div class="row py-3">
        <div v-if="error" class="error col-12">
           <div v-for="e in error" :key="e">
             <font-awesome-icon :icon="['fa', 'exclamation']" />
             <small class="pl-3">{{ e[0] }}</small>
           </div>
        </div>
        <div class="col-8" v-if="!phone">
          <div class="form-group">
            <input v-mask="['+7 (###) ###-##-##', '+7 (###) ###-##-##']" class="form-control"
                        required id="refilled-phone" v-model="inputs.user" type="tel"
                        @focusin="InputFocusIn('refilled-phone')"
                        @focusout="InputFocusOut('refilled-phone')"/>
              <label for="refilled-phone">Ваш номер телефона</label>
          </div>
        </div>

        <div v-bind:class="!phone ? 'col-4' : 'col-12 col-sm-6'">
          <div class="form-group">
            <input v-mask="['#####', '#####']" class="form-control"
                     required id="amount" v-model="inputs.amount"
                     @focusin="InputFocusIn('amount')" @focusout="InputFocusOut('amount')"/>
            <label for="amount">Сумма</label>
          </div>
        </div>
        <div v-bind:class="!phone ? 'col-12' : 'col-12 col-sm-6'">
          <div class="form-group pt-3">
            <button type="submit" class="btn btn-primary refill-btn">Оплатить</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'v-payment-create-form',
  props: ['phone'],
  data() {
    return {
      inputs: {
        user: '',
        amount: '',
      },
    };
  },
  computed: {
    ...mapState('payment', ['paymentData', 'error']),
  },
  methods: {
    createPayment() {
      this.$store.dispatch('payment/createPayment', this.inputs)
        .finally(() => {
          if (!this.error) {
            this.$router.push({
              name: 'checkout',
              params: { token: this.paymentData.confirmation_token },
            });
          }
        });
    },
  },
  mounted() {
    if (this.phone) {
      this.inputs.user = this.phone;
    }
  },
};
</script>
